export const arrSum = (arr) => arr.reduce((accumulator, itterator) => accumulator + itterator)